import { Switch, Route, withRouter } from "react-router-dom";
import React, { useEffect, Fragment } from "react";
import { Tabs } from "../common/Tabs";
import { useSelector, useDispatch } from "react-redux";
import { selectComplaint } from "../../redux/selectors";
import { loadComplaint } from "../../redux/actions";
import { Header } from "./Header";
import { CaseDetails } from "./CaseDetails";
import { Activities, ActivitiesActions } from "./activities/Activities";
import { Roles } from "./roles/Roles";
import { SecondaryAppBar } from "../common/SecondaryAppBar";
import { CircularProgress } from "@material-ui/core";
import { ComplaintLinkedRecords } from "./ComplaintLinkedRecords";
const _ComplaintDetails = ({ match }) => {
    const { data } = useSelector(selectComplaint);
    const dispatch = useDispatch();
    const { path, params } = match;
    const { id, tabId } = params;
    useEffect(() => {
        if (id) {
            dispatch(loadComplaint(id));
        }
    }, [dispatch, id]);
    return (React.createElement(Fragment, null,
        React.createElement(Tabs, { activeTabValue: tabId, tabs: [
                { tabId: "", label: "Case Details" },
                { tabId: "activity", label: "Activity", actions: React.createElement(ActivitiesActions, null) },
                { tabId: "permissions", label: "Permissions" },
                { tabId: "linked-records", label: "Linked Records" },
            ] }),
        React.createElement("div", { className: "CaseDetailsBody" }, data.id === id ? (React.createElement(Fragment, null,
            React.createElement(Header, { item: data }),
            React.createElement(Switch, null,
                React.createElement(Route, { path: `${path}/linked-records` },
                    React.createElement(ComplaintLinkedRecords, { id: id, model: data })),
                React.createElement(Route, { path: `${path}/activity` },
                    React.createElement(Activities, { model: data, key: data.id || "activities" })),
                React.createElement(Route, { path: `${path}/permissions` },
                    React.createElement(Roles, { model: data, key: data.id || "permissions" })),
                React.createElement(Route, { exact: true, path: `${path}/` },
                    React.createElement(CaseDetails, { model: data, key: data.id }))))) : (
        // if no model then prevent the sub bar and header flashing by having dummy placeholders
        React.createElement(Fragment, null,
            React.createElement(Header, { item: {} }),
            React.createElement(SecondaryAppBar, null,
                React.createElement(CircularProgress, { size: 24, color: "secondary" })))))));
};
export const ComplaintDetails = withRouter(_ComplaintDetails);
